import {
  getAdminV1Org,
  getAdminV1OrgSettings,
  patchAdminV1Org,
  patchAdminV1OrgSettings,
  type OrganizationProfile,
  type OrganizationSettings,
  type UpdateOrganizationProfileRequest,
  type UpdateOrganizationSettingsRequest,
} from '@nucleus-commerce/api-client/admin';

/** Organisation-wide settings and profile; only owners (org.write) may change them. */
export const organizationSettingsApi = {
  get: (): Promise<OrganizationSettings> => getAdminV1OrgSettings(),
  update: (body: UpdateOrganizationSettingsRequest): Promise<OrganizationSettings> =>
    patchAdminV1OrgSettings(body),
  profile: (): Promise<OrganizationProfile> => getAdminV1Org(),
  updateProfile: (body: UpdateOrganizationProfileRequest): Promise<OrganizationProfile> =>
    patchAdminV1Org(body),
};
